import { z } from 'zod';

/**
 * Currency enum
 *
 * @readonly
 * @enum SC - Sweeps Coin
 * @enum GC - Gold Coin
 */
export enum Currency {
  SC = 'SC',
  GC = 'GC',
  BSC = 'BSC',
}

export const CurrencyDTO = z.enum([Currency.SC, Currency.GC, Currency.BSC]);
